// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bIip","type":"styles_type__1qbjc","choices":"styles_choices__QEsFK"};